import { render, staticRenderFns } from "./WasteExchangeMainView.vue?vue&type=template&id=781380be&scoped=true"
import script from "./WasteExchangeMainView.vue?vue&type=script&lang=js"
export * from "./WasteExchangeMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781380be",
  null
  
)

export default component.exports